import * as React from "react";
const SvgFiRrHospitalUser = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-hospital-user_svg__a)">
      <path
        fill="#062147"
        d="M14 11V5c0-1.654-1.346-3-3-3H5C3.346 2 2 3.346 2 5v14c0 1.654 1.346 3 3 3h6a1 1 0 1 1 0 2H5c-2.757 0-5-2.243-5-5V5c0-2.757 2.243-5 5-5h6c2.757 0 5 2.243 5 5v6a1 1 0 1 1-2 0m-8 2H5a1 1 0 1 0 0 2h1a1 1 0 1 0 0-2m5 0h-1a1 1 0 1 0 0 2h1a1 1 0 1 0 0-2m-5 4H5a1 1 0 1 0 0 2h1a1 1 0 1 0 0-2m5 0h-1a1 1 0 1 0 0 2h1a1 1 0 1 0 0-2m-3-7a1 1 0 0 0 1-1V8h1a1 1 0 1 0 0-2H9V5a1 1 0 1 0-2 0v1H6a1 1 0 1 0 0 2h1v1a1 1 0 0 0 1 1m11 8a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5m4.969 4.751c-.561-2.173-2.649-3.75-4.969-3.75s-4.41 1.578-4.969 3.751a1 1 0 0 0 1.938.499c.329-1.282 1.633-2.249 3.031-2.249s2.701.967 3.031 2.25a1.001 1.001 0 0 0 1.938-.499z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-hospital-user_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrHospitalUser;
